import React, { useState, useEffect } from "react";
import loginHandler, { LOGIN, CHECK_TOKEN, LOGOUT } from "./utils/userAuthentication";
import { isLoginSuccessful, isLoginFailure } from "./utils/sessionStatus";
import { setCookie, getCookie, removeCookie } from "./utils/cookies";
import getDatabasesReferences from "./firebase/referencesHandler";
import firebase from "./firebase/firebase";

const USERCREDENTIALS = "userCredentials";
const AuthContext = React.createContext();

function AuthProvider({ children }) {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [userData, setUserData] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [databasesRef, setDatabasesRef] = useState({});

	async function logIn(credentials) {
		setIsLoading(true);
		const { status, userData } = await loginHandler({ type: LOGIN, payload: credentials });
		if (isLoginSuccessful(status)) {
			setCookie(USERCREDENTIALS, JSON.stringify(userData), 1440);
			await logInUser(userData);
		}
		if (isLoginFailure(status)) {
			alert("Ocurrio un error, por favor vuelva a intentarlo");
		}
		setIsLoading(false);
	}

	async function logInUser(user) {
		const references = await getDatabasesReferences(user);
		if (references !== null) {
			setUserData(user);
			setIsLoggedIn(true);
			setDatabasesRef(references);
		} else {
			console.log(references);
			logOut();
		}
	}

	function logOut() {
		loginHandler({ type: LOGOUT });
		removeCookie(USERCREDENTIALS);
		setUserData({});
		setIsLoggedIn(false);
	}

	useEffect(() => {
		async function keepSessionAlive(payload) {
			setIsLoading(true);
			const { status } = await loginHandler({ type: CHECK_TOKEN, payload });
			if (isLoginSuccessful(status)) {
				logInUser(payload);
			}
			if (isLoginFailure(status)) removeCookie(USERCREDENTIALS);
			setIsLoading(false);
		}
		async function checkLoginToServer() {
			const user = getCookie(USERCREDENTIALS);
			if (user) {
				const userData = JSON.parse(user);
				await keepSessionAlive(userData);
			}
		}
		checkLoginToServer();
		// eslint-disable-next-line
	}, []);

	return (
		<AuthContext.Provider
			value={{
				isLoggedIn,
				logOut,
				logIn,
				userData,
				isLoading,
				databasesRef,
				auth: firebase.functions().httpsCallable("getUserIDByEmail"),
			}}
		>
			{children}
		</AuthContext.Provider>
	);
}

export { AuthProvider, AuthContext };
